<template>
  <div class="col-md-12 mx-auto p-0">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="tutorial && tutorial.title ? tutorial.title : 'N/A'" routeBack="TutorialIndex"/>
        <div>
          <button v-if="isAdmin" class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
          <button v-if="isAdmin" class="show-action-btn delete" @click="clickOnDeleteBtn()">
            <trash-icon size="18"/>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('tutorial.title') }}</div>
                  <div> {{ getValue("title") }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('tutorial.duration') }}</div>
                  <div> {{ formatDuration(tutorial.duration) }}</div>
                </div>
              </div>
              <div class="col-md-6" v-if="tutorial.preview">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('tutorial.image.preview') }}</div>
                  <div v-if="tutorial.preview" class="picture-container">
                    <img :src="tutorial.preview ? getFileUrl(tutorial.preview.fileUrl) :''" alt=""
                         class="result-img"/>
                  </div>
                  <div v-else class="">
                    {{ "N/A" }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('tutorial.video') }}</div>
                  <video
                    v-if="videoBlobUrl"
                    id="videoElement"
                    class="w-100"
                    controls
                    controlsList="nodownload"
                    disablePictureInPicture
                  >
                    <source :src="videoBlobUrl" type="video/mp4">
                  </video>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="tutorial"
      controllerName="tutorial"
      itemSingularName="tutorial"
      itemSingularNameUpp="Tutorial"
      @didDeleteItem="didDeleteTutorial()">
    </Item-delete-modal>

  </div>
</template>

<script>

import BackArrow from "../../components/b122/BackArrow";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";
import api from "../../services/api";
import {formatDuration, intervalToDuration} from "date-fns";
import {fr} from "date-fns/locale";

export default {
  name: "TutorialShow",

  components: {
    BackArrow,
    ItemDeleteModal
  },

  data() {
    return {
      tutorialId: this.$route.params.tutorialId,
      tutorial: null,
      isAdmin: this.$store.getters.isAdmin,
      videoBlobUrl: null, // URL Blob pour la vidéo

    }
  },

  async mounted() {
    await this.fetchData()
  },

  computed: {
    getValue() {
      return property => (this.tutorial[property] || this.tutorial[property] === false) ? this.tutorial[property] : 'N/A'
    },
  },

  beforeDestroy() {
    if (this.videoBlobUrl) {
      URL.revokeObjectURL(this.videoBlobUrl);
    }
  },


  methods: {

    async fetchData() {
      await this.fetchTutorial()
      await this.fetchVideo();

    },

    async fetchVideo() {
      try {
        // Utiliser l'endpoint de la vidéo avec le Bearer token
        const response = await api.get(`/tutorial/showVideoFromWeb/${this.tutorial.video.id }`, {
          responseType: "blob",
        });

        // Créer une URL Blob et l'assigner pour le <video>
        this.videoBlobUrl = URL.createObjectURL(response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération de la vidéo :", error);
      }
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    async fetchTutorial() {
      await api
        .get(`/tutorial/${this.tutorialId}`)
        .then(response => {
          this.tutorial = response.data
        })
    },

    formatDuration(durationMs) {
      if (!durationMs) return 'N/A';
      // Utilise intervalToDuration pour obtenir la durée décomposée en heures, minutes, et secondes
      const duration = intervalToDuration({start: 0, end: durationMs});

      // Utilise formatDuration pour formater en HH:MM:SS
      return formatDuration(duration, {format: ['hours', 'minutes', 'seconds'], locale: fr});
    },


    clickOnEditBtn() {
      this.$router.push({
        name: 'TutorialEdit',
        params: {
          tutorialId: this.tutorialId
        }
      })
    },

    clickOnDeleteBtn() {
      if (this.isAdmin) {
        this.$bvModal.show('item-delete-modal')
      }
    },

    didDeleteTutorial() {
      this.$router.push({
        name: 'TutorialIndex'
      })
      this.$nextTick(() => {
        this.successToast(this.tutorial.title)
      })
    },

    successToast(contactName) {
      this.$bvToast.toast(this.$i18n.t('Tutorial') + ' "' + contactName + '" ' + this.$i18n.t('deleted'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },
  }
}
</script>

<style scoped>

.picture-container {
  width: 100%;
  max-height: 350px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.picture-container .result-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


</style>



// WEBPACK FOOTER //
// src/views/tutorial/TutorialShow.vue